import { environment } from '@env';
import {
  BrowserModule,
  HAMMER_GESTURE_CONFIG,
  HammerGestureConfig,
  HammerModule,
} from '@angular/platform-browser';
import { ErrorHandler, Injectable, NgModule } from '@angular/core';

// Module for Modals
import { ModalsHotelsModule } from '@modals/modals.module';
// Module for Components Shared
import { SharedModule } from './shared/shared.module';
// Module for Services
import { CoreModule } from '@core/core.module';
import { RouterModule } from '@angular/router';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { hotelsIcons } from './icons';
import { AppRoutingModule } from './app-routing.module';
import { AmExpertsToolsControlComponent } from '@am/experts-tools-control';
import { MbIconRegistry, MbProgressBarModule, MoebiusUIModule } from '@am/moebius';

import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { appReducer } from '@store/app.reducer';
import { EffectsModule } from '@ngrx/effects';
import { HotelAvailabilityEffects } from '@store/hotel-availability/hotel-availability.effects';
import { DisneyTicketsEffects } from '@store/disney-tickets/disney-tickets.effects';
import { registerLocaleData } from '@angular/common';
import localeEsAr from '@angular/common/locales/es-AR';

registerLocaleData(localeEsAr, 'es-AR');

const MOEBIUS_IMPORTS = [MoebiusUIModule, MbProgressBarModule];

const NGRX_IMPORTS = [
  StoreModule.forRoot(appReducer),
  EffectsModule.forRoot([DisneyTicketsEffects, HotelAvailabilityEffects]),
  StoreDevtoolsModule.instrument({
    name: 'Fe-Hotels-App',
    logOnly: environment.production,
    maxAge: 25,
  }),
];

@Injectable()
export class MyHammerConfig extends HammerGestureConfig {}

@NgModule({
  imports: [
    RouterModule,
    AmExpertsToolsControlComponent,
    ModalsHotelsModule,
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    AppRoutingModule,
    HammerModule,
    CoreModule.forRoot(),
    ...MOEBIUS_IMPORTS,
    ...NGRX_IMPORTS,
  ],
  providers: [
    // importProvidersFrom(HammerModule),
    { provide: HAMMER_GESTURE_CONFIG, useClass: MyHammerConfig },
  ],
})
export class AppModule {
  constructor(private mbIconRegistry: MbIconRegistry) {
    for (const icon of hotelsIcons) {
      this.mbIconRegistry.addSvgIconDefinition(icon);
    }
  }
}
